import { render, staticRenderFns } from "./GeneralRules_EN.vue?vue&type=template&id=0c49ae7c&scoped=true&"
import script from "./GeneralRules_EN.vue?vue&type=script&lang=js&"
export * from "./GeneralRules_EN.vue?vue&type=script&lang=js&"
import style0 from "./GeneralRules_EN.vue?vue&type=style&index=0&id=0c49ae7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c49ae7c",
  null
  
)

export default component.exports